<template>
  <div class="container">
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <b-col class="mt-4 p-4 card">
      <table class="table table-striped table-bordered">
        <thead style="position: sticky; top: 0; background-color: gray;">
          <tr>
            <th rowspan="2">No.</th>
            <th rowspan="2">Student</th>
          </tr>
          <tr>
            <th><b-form-checkbox class="m-2" v-model="applySame">Apply same mark for all students</b-form-checkbox></th>            
          </tr>
          <tr v-if="applySame">
            <th colspan="2"></th>
            <th>
              <b-form-input                
                v-model="sameMark"
                placeholder="Enter mark"
                type="number"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(student, studindex) in students" :key="studindex">
            <th class="fixed-table-column">{{ student.roll_number }}</th>
            <th class="fixed-table-column">
              {{ student.first_name }} {{ student.last_name }}
            </th>
            <td style="min-width: 60px;">
              <b-form-input v-model="moderationData[student.institution_user_id]"
                type="number" placeholder="Enter score" :disabled="applySame"></b-form-input>
            </td>
          </tr>
        </tbody>
      </table>

      <div>
        <b-button @click="updateModerationData()"
          :disabled="updateModerationBtn !== 'Save'" variant="primary">
          {{ updateModerationBtn }}
        </b-button>
      </div>
    </b-col>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["course_id"],
  async created() {
    await this.fetchCourseStudents();
    this.students.forEach(stud => {
      this.$set(this.moderationData, stud.institution_user_id, null);
    });
    this.fetchData = false;
    console.log('Fetching moderation data for course_id:', this.moderationData);
    await this.getModerationData();
  },
  data() {
    return {
      fetchData: false,
      updateModerationBtn: "Save",
      students: [],
      classParticipantsMaxScore: null,
      evaluationTableData: {},
      moderationData: {},
      applySame: false,
      sameMark: null,
    }
  },
  watch: {
    sameMark(value) {
      if (this.applySame) {
        console.log('Applying same mark:', value);
        this.students.forEach(stud => {
          this.$set(this.moderationData, stud.institution_user_id, value);
        });
      }
      console.log('sameMark changed:', this.moderationData);
    },
    applySame(val) {
      if (val) {
        Object.entries(this.moderationData).forEach(moderation => {
          moderation.score = this.sameMark;
        });
      }
      console.log('applySame changed:', this.moderationData);
    }
  },
  methods: {

    async getModerationData() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/moderations?course=${this.course_id}`;
      try {
        const response = await axios.get(url);
        this.classParticipantsMaxScore = response.data.max_score;

        response.data.moderations.forEach(moderation => {
          if (Object.prototype.hasOwnProperty.call(this.moderationData, moderation.student_id)) {
            this.$set(this.moderationData, moderation.student_id, parseFloat(moderation.score));
          }
        });

      } catch (error) {
        console.error("Error fetching moderations:", error);
      }
    },

    async updateModerationData() {
      this.updateModerationBtn = "Saving...";
      const postData = [];

      for (const [studkey, score] of Object.entries(this.moderationData)) {
        if (score !== null) {
          postData.push({
            score: score,
            student_id: studkey
          });
        }
      }

      const url = `${this.$store.getters.getAPIKey.mainAPI}/moderations`;
      try {
        let response = await axios.post(url, {
          moderationData: postData,
          course_id: this.course_id,
        });

        this.$toast.success(response.data.message, {
          position: "top",
          duration: 3000,
        });
      } catch (error) {
        this.$toast.error("Failed to update", {
          position: "top",
          duration: 3000,
        });
        this.fetchData = false;
      }

      this.updateModerationBtn = "Save";
    },

    async fetchCourseStudents() {
      const mainUrl = this.$store.getters.getAPIKey.createStudent;
      const url = mainUrl.replace("course_id", this.course_id);

      try {
        const response = await this.$axios.get(url);
        this.students = response.data[0] || [];
      } catch (error) {
        console.error("Error fetching students:", error);
      }
    },
  },
};
</script>

<style>
.tag-button button {
  font-size: 9px !important;
  padding: 3px;
}

.labEvaluation .modal-dialog {
  max-width: 100%;
  max-height: 100vh;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  position: fixed;
  z-index: 100000;
}

.labEvaluation .modal-body {
  overflow: scroll;
}

.labEvaluation .fixed-table-column {
  position: sticky;
  left: 0;
  background-color: gray;
}
</style>
